import { Map } from 'immutable';

import gatwick from './gatwick';


/**
 * Custom messages for Gatwick Express - British Airways
 */

const micrositeMessages = new Map({
    'app.owner': 'Gatwick Express - British Airways'
});

module.exports = gatwick.merge(micrositeMessages);



// WEBPACK FOOTER //
// ./src/messages/gatwick-ba.js